<template>
    <!-- Newsletter -->
    <section class="section newsletter-sport">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="subscribe-style aos" data-aos="fade-up">
                        <div class="banner-blk">
                            <img src="@/assets/img/subscribe-bg.jpg" class="img-fluid" alt="Subscribe">
                        </div>
                        <div class="banner-info ">
                            <img src="@/assets/img/icons/subscribe.svg" class="img-fluid" alt="Subscribe">
                            <h2>Subscribe to Newsletter</h2>
                            <p>Just for you, exciting badminton news updates.</p>
                            <div class="subscribe-blk bg-white">
                                <div class="input-group align-items-center">
                                    <i class="feather-mail"></i>
                                    <input type="email" class="form-control" placeholder="Enter Email Address"
                                        aria-label="email">
                                    <div class="subscribe-btn-grp">
                                        <input type="submit" class="btn btn-secondary" value="Subscribe">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- /Newsletter -->
</template>